import React from "react";
import { Link } from "gatsby";

import { FaHeart } from "react-icons/fa";

const Footer = ({ location }) => {
  return (
    <footer className="mx-auto p-8 w-full text-center pin-b text-grey-dark">
        <a href="https://www.eldotravo.fr/pro/batiments_en_transition">
          <iframe
            src="https://www.eldotravo.fr/widget/artisan/99329"
            frameborder="0" height="120px"
            width="120px"
            // style="position: fixed;right: 5px;bottom: 48%;z-index:100 !important;opacity: 1"
            className="mb-2" />
        </a>
      <div className="mb-2">
        <a
          className="no-underline text-grey-darker hover:underline m-2"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.facebook.com/Batiments.en.Transition/"
        >
          Facebook
        </a>
        {location.pathname === "/contacts" ? null : (
          <Link to="/contacts" className="no-underline text-grey-darker hover:underline m-2">
            Contacts
          </Link>
        )}
      </div>
      <small>
        &copy; {1900 + new Date().getYear()} , made with <FaHeart /> by a coder
        for a worker
      </small>
    </footer>
  );
};

export default Footer;
